function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="172" height="172" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M35 96.69L69.244 131l83.4-87L144 35.546 69.244 112.25 44.31 87.315z" fill="#6DD401" /><path d="M135.253 22.96C100.436-4.243 50.16 1.93 22.959 36.746c-7.4 9.473-12.331 20.09-14.886 31.075a80.243 80.243 0 0 0-.846 32.141 80.04 80.04 0 0 0 9.172 25.522c5.02 8.858 11.826 16.898 20.348 23.556 34.817 27.201 85.092 21.028 112.294-13.788 18.426-23.585 21.538-54.263 10.806-80.058" stroke="#6DD401" strokeWidth="11" /></g></svg>;
});